const ReportIndex = () => import('@/modules/reports/views/ReportIndex')

export default [
  {
    path: '/reports',
    name: 'reports.index',
    component: ReportIndex,
    meta: { requiresAuthentication: true }
  }
]
